/**
 * <cart-icon-bubble> — header cart-count badge.
 *
 * Wraps the `cart-button-inner` content in `snippets/header.liquid`.
 * Listens for `cart:update`, swaps its own innerHTML from
 * `event.detail.sections['cart-icon-bubble']`, and keeps the parent
 * `#cart-button[data-count]` attribute in sync (used by CSS to style
 * the dot indicator).
 *
 * Replaces `commonCart.updateCountAndPrice`'s count-display half.
 *
 * Source path: theme/js/components/cart-icon-bubble.esm.js
 * Built name : ./cart-icon-bubble.js
 *
 * AI: Entirely written by AI
 * Date: 2026-05-07
 * Model: Claude Opus 4.7
 * Updated: 2026-05-07 (Claude Opus 4.7) — section id + parseSection
 *   imported from core/sections.esm.js.
 * Updated: 2026-06-02 (Claude Opus 4.7) — reset _wired in disconnectedCallback
 *   so the document listener is re-attached when Turbo transplants the
 *   permanent #header-global across navigations.
 *
 * [CartIconBubble]
 */

import { log } from './log.js';
import { SECTION_CART_ICON_BUBBLE, parseSection } from './sections.js';

class CartIconBubble extends HTMLElement {
  constructor() {
    super();
    this._onCartUpdate = this._onCartUpdate.bind(this);
  }

  connectedCallback() {
    if (this._wired) return;
    this._wired = true;
    document.addEventListener('cart:update', this._onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this._onCartUpdate);
    // Reset so connectedCallback re-wires on Turbo's permanent-header transplant.
    this._wired = false;
  }

  _onCartUpdate(event) {
    const detail = event && event.detail;
    if (!detail) return;
    const sections = detail.sections || {};
    const parsed = parseSection(sections[SECTION_CART_ICON_BUBBLE], SECTION_CART_ICON_BUBBLE);
    if (parsed) this.innerHTML = parsed.innerHTML;

    const parent = this.parentElement;
    const cart = detail.cart;
    if (parent && cart && cart.normalized) {
      const next = String(cart.normalized.item_count);
      if (parent.getAttribute('data-count') !== next) {
        parent.setAttribute('data-count', next);
      }
    }
  }
}

if (!customElements.get('cart-icon-bubble')) {
  customElements.define('cart-icon-bubble', CartIconBubble);
}

log('[CartIconBubble] registered');
